import { invoke } from '~/lib/tauriInvoke'
import { AsyncQueue } from './queue'
import { liveKitManager } from './manager'

type VoiceCredentials = { token: string; server_url: string }

/**
 * Requests the gRPC channel lease (`start_channel_connection`) and kicks off
 * the matching `LiveKitManager` connection. Every transition is serialized
 * through its own queue, independent of `LiveKitManager`'s media queue.
 */
export class VoiceConnectionCoordinator {
  private readonly queue = new AsyncQueue()

  connect(channelId: string, options?: { canSpeak?: boolean; audioBitrateKbps?: number }): Promise<void> {
    return this.queue.run(async () => {
      if (liveKitManager.state.activeVoiceChannelId === channelId) return
      await this.leaveCurrentChannel()

      const credentials = await invoke<VoiceCredentials>('start_channel_connection', { channelId })
      await liveKitManager.connect(channelId, credentials.server_url, credentials.token, options)
    })
  }

  disconnect(): Promise<void> {
    return this.queue.run(() => this.leaveCurrentChannel())
  }

  private async leaveCurrentChannel(): Promise<void> {
    await liveKitManager.disconnect()
  }
}

export const voiceConnectionCoordinator = new VoiceConnectionCoordinator()
